<template>
  <span
    v-if="pinned && label"
    class="cs-pin-chip inline-flex shrink-0 flex-col items-center leading-none"
    data-testid="pinned-song"
  >
    <i class="pi pi-thumbtack text-xl sm:text-2xl"></i>
    <span class="text-[10px] font-semibold uppercase tracking-wide sm:text-xs">
      {{ label }}
    </span>
  </span>
  <i
    v-else-if="pinned"
    class="pi pi-thumbtack shrink-0"
    :class="iconClass"
    title="Pinned"
    data-testid="pinned-song"
  ></i>
</template>

<script setup>
defineOptions({ name: "PinnedSongMark" });

defineProps({
  pinned: { type: Boolean, default: false },
  // With a label the mark becomes a chip; without one it stays a bare icon for
  // tight layouts such as the LED wall.
  label: { type: String, default: "" },
  iconClass: { type: String, default: "text-sm text-amber-600 dark:text-amber-300" }
});
</script>
